import { Injectable } from "@angular/core";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class UserSummaryConfigService {
	constructor(private configService: ConfigService) {}

	/**
	 * This config is under jurisdiction
	 */
	getBonusVisible$(): Observable<boolean | undefined> {
		return this.configService.get$((config) => config.commonUi.userSummary.isBonusVisible, true);
	}

	getWithdrawLayoutEnabled(): boolean {
		return this.configService.get((config) => config.coreUi.header.withdrawLayoutEnabled, false);
	}

	isTicketCounterEnabled(): boolean {
		return this.configService.get((config) => config.coreUi.header.isTicketCounterEnabled, false);
	}
}
